var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankAgropromkredit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#02ACE2",
    d: "M9.22 28.2c-.13-.2-.23-.35-.31-.5-2.45-4.23-4.88-8.43-7.3-12.65C-.54 11.3-.52 7.53 1.6 3.76L3.76 0l.29.49c2.44 4.23 4.88 8.43 7.3 12.65 2.17 3.77 2.2 7.53.05 11.3L9.22 28.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FE720A",
    d: "M39.08 18.8h-.52c-4.92 0-9.84.03-14.8 0a10.64 10.64 0 0 1-9.62-5.55L12.2 9.86c-.08-.13-.13-.27-.24-.46.22 0 .38-.03.55-.03 4.86 0 9.73-.03 14.6 0a10.8 10.8 0 0 1 9.84 5.7l1.9 3.26c.08.14.13.28.24.47Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0062A4",
    d: "m5.15 40 .28-.52c2.45-4.24 4.86-8.44 7.31-12.65 2.17-3.74 5.45-5.6 9.76-5.66h4.35l-.28.5c-2.45 4.23-4.86 8.43-7.31 12.64A10.65 10.65 0 0 1 9.5 40H5.15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankAgropromkredit);
export default ForwardRef;